import React from 'react';

export type VideoThumbProps = {
    src: string;
    /** Class applied to the wrapper (sizing/layout comes from the existing thumb classes). */
    className?: string;
};

/**
 * Video thumbnail that shows a play icon and plays (muted, looping) while hovered.
 * The wrapper receives the existing *.thumb* sizing classes; the inner video fills it.
 */
class VideoThumb extends React.Component<VideoThumbProps> {
    private _videoRef = React.createRef<HTMLVideoElement>();

    private _onMouseEnter = () => {
        const video = this._videoRef.current;
        if (!video) return;
        // Restart from the beginning on every hover.
        video.currentTime = 0;
        // Hover-triggered playback can be rejected (e.g. metadata not ready yet) — not fatal, ignore.
        void video.play().catch(() => { });
    };

    private _onMouseLeave = () => {
        this._videoRef.current?.pause();
    };

    render() {
        const { src, className } = this.props;
        return (
            <div
                className={`video-thumb-wrapper${className ? ` ${className}` : ''}`}
                onMouseEnter={this._onMouseEnter}
                onMouseLeave={this._onMouseLeave}
            >
                <video ref={this._videoRef} src={src} muted loop playsInline preload="metadata" className="video-thumb" />
                <span className="video-thumb-play-icon">▶</span>
            </div>
        );
    }
}

export default VideoThumb;
